import { render, staticRenderFns } from "./base-tool.vue?vue&type=template&id=b04d0dee&scoped=true"
import script from "./base-tool.vue?vue&type=script&lang=js"
export * from "./base-tool.vue?vue&type=script&lang=js"
import style0 from "./base-tool.vue?vue&type=style&index=0&id=b04d0dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04d0dee",
  null
  
)

export default component.exports